import { Accordion } from './includes/Accordion'
import { Scroll } from './includes/Scroll'
import {ToggleMenu} from "./includes/ToggleMenu";

Accordion();
Scroll();
ToggleMenu();